import {css} from '@emotion/core'
import styled from '@emotion/styled'
import { darkRed, ipadproMax, marketingMobileCuttoff } from "@css/constants";
import {Card, CardContent, CardText} from "@css/common.elements";
import {fontSize} from "@css/styles";
import {FontNormal} from "@css/fonts";
import {FormWrapper} from "@pages/Homepage/components/HeroSection/HeroSection.elements";
import {Button} from "@components/Button";

export const ArticleLeadgenCardContainer = styled('div')(css`
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  align-items: right;
`)

export const ArticleLeadgenCardContent = styled(CardContent)(css`
  padding: 25px 0;
  width: 75%;

  @media(min-width: ${marketingMobileCuttoff}) and (max-width: ${ipadproMax}) {
    width: 85%;
  }
`)

export const ArticleLeadgenStyledCard = styled(Card)(css`
`)

export const ArticleLeadgenCardSubtitle = styled(CardText)(css`
  ${fontSize(16)};
`)

export const StyledFormWrapper = styled(FormWrapper)(css`
  text-align: center;
  margin-top: 20px;

  & > div > label {
    ${FontNormal(600)};
  }
`)

export const StyledButton = styled(Button)(css`
  width: 100%;
  margin-top: 26px;
  margin-bottom: 10px;
`)

export const FormQuestionWrapper = styled('div')(css`
  position: relative;
  width: 100%;
`)

export const BtnHelperText = styled('div')(css`
  ${FontNormal(600)};
  ${fontSize(16)};
  font-style: italic;
  margin-top: 6px;
  text-align: center;
`)

export const ErrorText = styled('div')(css`
  ${FontNormal(600)};
  ${fontSize(16)};
  color: ${darkRed};
  margin-top: 2px;
  position: absolute;
  text-align: center;
  width: 100%;
`)
